import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './styles/permission.css';

import App from './App.vue';
import router from './router';
import { setupPermissionDirective } from './directives/permission';

// 清理 chunk 恢复时写入的缓存冲刷参数，避免污染地址栏
try {
  const url = new URL(window.location.href);
  if (url.searchParams.has('_chunk_reload')) {
    url.searchParams.delete('_chunk_reload');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  }
} catch {
  // ignore
}

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ElementPlus);

// 注册权限指令
setupPermissionDirective(app);

app.mount('#app');

